import { Link } from "react-router-dom";
import { Car, Users } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { ROUTE_PATHS } from "@/routes/routePaths";

export const TrustedBySection = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-white border-y border-gray-100 pt-0 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-base sm:text-lg font-medium text-gray-700">
          {t("badge", "hero")}
        </p>
      </div>
    </section>
  );
};

export const RideInventorySections = () => {
  const { t } = useLanguage();

  return (
    <section className="py-12 bg-gradient-to-br from-gray-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900">
            Explore Rides
          </h2>
          <p className="mt-2 text-gray-600">
            Explore live demand and supply across routes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to={ROUTE_PATHS.RIDE_REQUESTS}
            className="group rounded-2xl border border-orange-200 bg-white p-6 shadow-sm hover:shadow-md transition-all"
          >
            <div className="flex items-center gap-3 mb-3">
              <Users className="w-6 h-6 text-[#22C55E]" />
              <h3 className="text-xl font-semibold text-gray-900">{t("waitingGuests", "header")}</h3>
            </div>
            <p className="text-gray-600">
              View travelers looking for rides and match available seats.
            </p>
          </Link>

          <Link
            to={ROUTE_PATHS.FIND_RIDES}
            className="group rounded-2xl border border-orange-200 bg-white p-6 shadow-sm hover:shadow-md transition-all"
          >
            <div className="flex items-center gap-3 mb-3">
              <Car className="w-6 h-6 text-[#22C55E]" />
              <h3 className="text-xl font-semibold text-gray-900">{t("availableRides", "header")}</h3>
            </div>
            <p className="text-gray-600">
              Browse host routes and seats available for upcoming travel.
            </p>
          </Link>
        </div>
      </div>
    </section>
  );
};
